import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ProductsSection from '@/pages/home/components/ProductsSection';

const heroBg = 'https://readdy.ai/api/search-image?query=A%20bright%20flat%20lay%20of%20fashionable%20streetwear%20clothing%20and%20accessories%20including%20sneakers%20hoodies%20bags%20and%20watches%20arranged%20on%20a%20clean%20white%20and%20beige%20studio%20surface%20with%20soft%20daylight%2C%20high%20end%20editorial%20product%20photography%2C%20airy%20and%20fresh%20composition&width=1920&height=1080&seq=hero-main-bg-v2&orientation=landscape&nocache=true';

const catImages = [
  'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20white%20leather%20sneakers%20photographed%20on%20a%20concrete%20urban%20sidewalk%20with%20soft%20morning%20light%20and%20blurred%20city%20background%2C%20street%20style%20product%20photography%2C%20crisp%20detail%2C%20fresh%20modern%20aesthetic&width=600&height=600&seq=cat-shoes-v2-01&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20folded%20pastel%20beige%20oversized%20hoodie%20on%20a%20wooden%20bench%20with%20soft%20daylight%20and%20a%20potted%20plant%20nearby%2C%20cozy%20minimal%20apparel%20product%20photography%2C%20warm%20and%20airy&width=600&height=600&seq=cat-hoodie-v2-02&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20stack%20of%20colorful%20graphic%20cotton%20t-shirts%20in%20coral%20blue%20and%20olive%20folded%20neatly%20on%20a%20bright%20white%20surface%2C%20flat%20lay%20apparel%20product%20photography%2C%20vibrant%20yet%20clean&width=600&height=600&seq=cat-tshirt-v2-03&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20black%20leather%20biker%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20neutral%20studio%20wall%20with%20soft%20dramatic%20lighting%2C%20fashion%20outerwear%20product%20photography%2C%20elegant%20and%20sharp&width=600&height=600&seq=cat-jacket-v2-04&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=Several%20pairs%20of%20denim%20jeans%20and%20khaki%20chinos%20folded%20in%20a%20neat%20stack%20on%20a%20light%20grey%20concrete%20surface%2C%20soft%20natural%20light%2C%20menswear%20bottoms%20product%20photography%2C%20clean%20minimal&width=600&height=600&seq=cat-pants-v2-05&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=An%20arrangement%20of%20colorful%20baseball%20caps%20and%20beanies%20on%20white%20wooden%20shelves%20in%20a%20bright%20store%2C%20accessories%20product%20photography%2C%20soft%20daylight%2C%20playful%20and%20tidy&width=600&height=600&seq=cat-headwear-v2-06&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20tracksuit%20set%20in%20sage%20green%20folded%20with%20sneakers%20on%20a%20light%20linen%20surface%2C%20athleisure%20outfit%20product%20photography%2C%20soft%20natural%20light%2C%20clean%20composition&width=600&height=600&seq=cat-sets-v2-07&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20cotton%20underwear%20and%20socks%20in%20neutral%20pastel%20tones%20arranged%20on%20a%20white%20marble%20counter%2C%20basics%20product%20photography%2C%20bright%20and%20airy%2C%20minimal%20aesthetic&width=600&height=600&seq=cat-underwear-v2-08&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20football%20soccer%20jersey%20in%20bold%20red%20and%20white%20hanging%20on%20a%20hanger%20against%20a%20clean%20studio%20backdrop%2C%20sportswear%20product%20photography%2C%20crisp%20detail%2C%20energetic%20and%20fresh&width=600&height=600&seq=cat-jersey-v2-09&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20luxury%20flat%20lay%20of%20a%20wristwatch%20leather%20bracelet%20and%20sunglasses%20on%20a%20warm%20beige%20linen%20surface%20with%20soft%20side%20light%2C%20accessories%20product%20photography%2C%20refined%20and%20elegant&width=600&height=600&seq=cat-accessories-v2-10&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=A%20collection%20of%20designer%20leather%20handbags%20and%20backpacks%20in%20tan%20brown%20and%20black%20displayed%20on%20a%20light%20wooden%20table%2C%20bags%20product%20photography%2C%20soft%20daylight%2C%20premium%20look&width=600&height=600&seq=cat-bags-v2-11&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=Several%20coiled%20leather%20and%20canvas%20belts%20in%20brown%20black%20and%20tan%20arranged%20in%20a%20row%20on%20a%20bright%20white%20surface%2C%20accessories%20product%20photography%2C%20clean%20and%20orderly&width=600&height=600&seq=cat-belts-v2-12&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottles%20with%20amber%20and%20clear%20liquids%20arranged%20on%20a%20reflective%20surface%20with%20soft%20golden%20light%2C%20fragrance%20product%20photography%2C%20luxurious%20and%20fresh&width=600&height=600&seq=cat-perfume-v2-13&orientation=squarish&nocache=true',
  'https://readdy.ai/api/search-image?query=An%20assorted%20collection%20of%20lifestyle%20items%20including%20sunglasses%20gloves%20and%20small%20accessories%20arranged%20on%20a%20bright%20neutral%20surface%2C%20misc%20product%20photography%2C%20soft%20daylight%2C%20varied%20and%20tidy&width=600&height=600&seq=cat-other-v2-14&orientation=squarish&nocache=true',
];

export default function Home() {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const categories = t('categories', { returnObjects: true }) as Array<{ name: string; url: string }>;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    setLangOpen(false);
    setMenuOpen(false);
  };

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' },
    { code: 'de', label: 'Deutsch' },
    { code: 'da', label: 'Dansk' },
  ];

  return (
    <div className="min-h-screen bg-warm-50">
      {/* Navbar — always visible white bar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-sage-100">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-between h-16 md:h-20">
            <a href="/" className="flex items-center gap-2">
              <span className="font-heading font-bold text-lg md:text-xl tracking-tight text-sage-800">
                AllChinaBuy<span className="font-light">Spreadsheet</span>
              </span>
            </a>

            <div className="flex items-center gap-2 md:gap-6">
              <div className="hidden md:flex items-center gap-6">
                <Link to="/" className="text-sm font-medium text-sage-800 hover:text-coral-500 transition whitespace-nowrap">
                  {t('navHome')}
                </Link>
                <Link to="/article/allchinabuy-buying-guide-beginners" className="text-sm font-medium text-sage-800 hover:text-coral-500 transition whitespace-nowrap">
                  {t('navShoppingGuide')}
                </Link>
                <a href="#categories" className="text-sm font-medium text-sage-800 hover:text-coral-500 transition whitespace-nowrap">
                  {t('navCategories')}
                </a>
                <a href="#articles" className="text-sm font-medium text-sage-800 hover:text-coral-500 transition whitespace-nowrap">
                  {t('navGuides')}
                </a>
                <a href="#products" className="text-sm font-medium text-sage-800 hover:text-coral-500 transition whitespace-nowrap">
                  Products
                </a>
                <a href="#trust" className="text-sm font-medium text-sage-800 hover:text-coral-500 transition whitespace-nowrap">
                  {t('navAbout')}
                </a>
              </div>

              <div className="relative">
                <button
                  onClick={() => setLangOpen(!langOpen)}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition bg-sage-100 text-sage-800 hover:bg-sage-200"
                >
                  <i className="ri-global-line w-4 h-4 flex items-center justify-center" />
                  <span className="hidden sm:inline">{languages.find(l => l.code === i18n.language)?.label || 'English'}</span>
                  <i className={`ri-arrow-down-s-line w-4 h-4 flex items-center justify-center transition-transform ${langOpen ? 'rotate-180' : ''}`} />
                </button>
                {langOpen && (
                  <div className="absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-lg border border-sage-100 overflow-hidden z-50">
                    {languages.map(lang => (
                      <button
                        key={lang.code}
                        onClick={() => changeLanguage(lang.code)}
                        className={`w-full text-left px-4 py-2.5 text-sm hover:bg-sage-50 transition ${i18n.language === lang.code ? 'text-sage-700 font-medium bg-sage-50' : 'text-sage-800'}`}
                      >
                        {lang.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Mobile hamburger */}
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="md:hidden w-10 h-10 rounded-lg bg-sage-100 flex items-center justify-center text-sage-800"
                aria-label="Menu"
              >
                <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} w-5 h-5 flex items-center justify-center`} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-sage-100 max-h-[75vh] overflow-y-auto">
            <div className="px-4 py-4 space-y-1">
              <Link to="/" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3 py-3 rounded-lg text-sage-800 font-medium hover:bg-sage-50 transition">
                <i className="ri-home-4-line w-5 h-5 flex items-center justify-center text-coral-500" />
                {t('navHome')}
              </Link>
              <Link to="/article/allchinabuy-buying-guide-beginners" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3 py-3 rounded-lg text-sage-800 font-medium hover:bg-sage-50 transition">
                <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center text-coral-500" />
                {t('navShoppingGuide')}
              </Link>
              <a href="#articles" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3 py-3 rounded-lg text-sage-800 font-medium hover:bg-sage-50 transition">
                <i className="ri-article-line w-5 h-5 flex items-center justify-center text-coral-500" />
                {t('navGuides')}
              </a>
              <a href="#products" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3 py-3 rounded-lg text-sage-800 font-medium hover:bg-sage-50 transition">
                <i className="ri-shopping-bag-3-line w-5 h-5 flex items-center justify-center text-coral-500" />
                Products
              </a>
              <a href="#trust" onClick={() => setMenuOpen(false)} className="flex items-center gap-3 px-3 py-3 rounded-lg text-sage-800 font-medium hover:bg-sage-50 transition">
                <i className="ri-information-line w-5 h-5 flex items-center justify-center text-coral-500" />
                {t('navAbout')}
              </a>

              <div className="pt-4 mt-2 border-t border-sage-100">
                <p className="px-3 pb-2 text-xs font-semibold uppercase tracking-wide text-sage-500">{t('navCategories')}</p>
                <div className="grid grid-cols-2 gap-2">
                  {categories.map((cat, idx) => (
                    <a
                      key={idx}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMenuOpen(false)}
                      className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-sage-50 hover:bg-sage-100 transition"
                    >
                      <img src={catImages[idx]} alt={cat.name} className="w-8 h-8 rounded-lg object-cover flex-shrink-0" />
                      <span className="text-xs font-medium text-sage-800 leading-tight">{cat.name}</span>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-16 md:pt-20">
        <div className="absolute inset-0">
          <img src={heroBg} alt="Fashion products background" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
        </div>
        <div className="relative z-10 text-center px-4 md:px-8 max-w-5xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white/90 text-sm mb-6">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center" />
            {t('trustIndependent')}
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 text-balance">
            {t('heroH1')}
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-3xl mx-auto mb-10 leading-relaxed">
            {t('heroSub')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-coral-500 text-white font-semibold text-sm hover:bg-coral-600 transition whitespace-nowrap"
            >
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" />
              {t('ctaMain')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-white text-sage-800 font-semibold text-sm hover:bg-white/90 transition whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center" />
              {t('ctaBuyNow')}
            </a>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 text-white/60 text-sm">
            <span className="flex items-center gap-1.5"><i className="ri-check-double-line w-4 h-4 flex items-center justify-center" /> {t('trustVerified')}</span>
            <span className="flex items-center gap-1.5"><i className="ri-time-line w-4 h-4 flex items-center justify-center" /> {t('trustUpdated')}</span>
            <span className="flex items-center gap-1.5"><i className="ri-group-line w-4 h-4 flex items-center justify-center" /> {t('trustCommunity')}</span>
          </div>
        </div>
      </section>

      {/* Category Section */}
      <section id="categories" className="py-16 md:py-24 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-sage-900 mb-4">{t('categoryTitle')}</h2>
            <p className="text-sage-600 max-w-2xl mx-auto">{t('categorySubtitle')}</p>
          </div>

          {/* Dropdown */}
          <div className="max-w-md mx-auto mb-12 relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full flex items-center justify-between px-6 py-4 rounded-xl bg-sage-50 border border-sage-200 text-sage-800 font-medium hover:bg-sage-100 transition"
            >
              <span className="flex items-center gap-2">
                <i className="ri-grid-line w-5 h-5 flex items-center justify-center" />
                {t('selectCategory')}
              </span>
              <i className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
            </button>
            {dropdownOpen && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-xl border border-sage-100 overflow-hidden z-30 max-h-80 overflow-y-auto">
                {categories.map((cat, idx) => (
                  <a
                    key={idx}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setDropdownOpen(false)}
                    className="flex items-center gap-3 px-5 py-3 hover:bg-sage-50 transition text-sage-800 border-b border-sage-50 last:border-0"
                  >
                    <img src={catImages[idx]} alt={cat.name} className="w-12 h-12 rounded-lg object-cover flex-shrink-0" />
                    <span className="text-sm font-medium">{cat.name}</span>
                    <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center ml-auto text-sage-400" />
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Category Grid — image cards with text labels */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
            {categories.map((cat, idx) => (
              <a
                key={idx}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group relative rounded-2xl overflow-hidden aspect-square bg-sage-50"
              >
                <img
                  src={catImages[idx]}
                  alt={cat.name}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-3">
                  <span className="block text-xs md:text-sm font-semibold text-white leading-tight drop-shadow">{cat.name}</span>
                </div>
                <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center absolute top-2 right-2 text-white bg-black/30 rounded-full p-1 opacity-0 group-hover:opacity-100 transition" />
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Products Section */}
      <ProductsSection />

      {/* Articles Section */}
      <section id="articles" className="py-16 md:py-24 bg-warm-50">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-sage-900 mb-4">{t('articleTitle')}</h2>
            <p className="text-sage-600 max-w-2xl mx-auto">{t('articleSubtitle')}</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {articles.map((article) => (
              <article key={article.slug} className="bg-white rounded-2xl overflow-hidden border border-sage-100 hover:shadow-lg transition group flex flex-col">
                <div className="aspect-video overflow-hidden">
                  <img src={article.image} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <div className="flex items-center gap-2 text-xs text-sage-500 mb-2">
                    <span className="px-2 py-0.5 rounded-full bg-sage-100 text-sage-700 font-medium">{article.tag}</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-sage-900 mb-3 group-hover:text-coral-600 transition leading-snug">
                    <Link to={`/article/${article.slug}`}>{article.title}</Link>
                  </h3>
                  <p className="text-sm text-sage-600 mb-4 leading-relaxed flex-1">{article.description}</p>
                  <Link to={`/article/${article.slug}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-coral-500 hover:text-coral-600 transition mt-auto">
                    {t('readMore')}
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section to Main Website */}
      <section className="py-16 md:py-24 bg-sage-800 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img src={heroBg} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
            {t('ctaMain')}
          </h2>
          <p className="text-white/70 mb-8 max-w-2xl mx-auto">
            Ready to discover the best products from AllChinaBuy? Visit our main spreadsheet platform for live links, updated prices, and curated collections across every category.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-coral-500 text-white font-semibold text-sm hover:bg-coral-600 transition whitespace-nowrap"
            >
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center" />
              {t('ctaMain')}
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-white/10 text-white border border-white/20 font-semibold text-sm hover:bg-white/20 transition backdrop-blur-sm whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line w-4 h-4 flex items-center justify-center" />
              {t('ctaBuyNow')}
            </a>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section id="trust" className="py-16 bg-white border-t border-sage-100">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-sage-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-xl text-sage-600 w-5 h-5 flex items-center justify-center" />
              </div>
              <h3 className="font-semibold text-sage-900 text-sm mb-1">{t('trustIndependent')}</h3>
              <p className="text-xs text-sage-500">Not affiliated with AllChinaBuy</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-sage-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-verified-badge-line text-xl text-sage-600 w-5 h-5 flex items-center justify-center" />
              </div>
              <h3 className="font-semibold text-sage-900 text-sm mb-1">{t('trustVerified')}</h3>
              <p className="text-xs text-sage-500">Community-checked resources</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-sage-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-refresh-line text-xl text-sage-600 w-5 h-5 flex items-center justify-center" />
              </div>
              <h3 className="font-semibold text-sage-900 text-sm mb-1">{t('trustUpdated')}</h3>
              <p className="text-xs text-sage-500">Fresh data every week</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 rounded-xl bg-sage-50 flex items-center justify-center mx-auto mb-3">
                <i className="ri-group-3-line text-xl text-sage-600 w-5 h-5 flex items-center justify-center" />
              </div>
              <h3 className="font-semibold text-sage-900 text-sm mb-1">{t('trustCommunity')}</h3>
              <p className="text-xs text-sage-500">Built by shoppers, for shoppers</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-sage-900 text-white/80 py-12 md:py-16">
        <div className="w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 md:gap-12 mb-10">
            <div>
              <h3 className="font-heading text-lg font-bold text-white mb-4">
                AllChinaBuy<span className="font-light">Spreadsheet</span>
              </h3>
              <p className="text-sm text-white/60 leading-relaxed mb-4">
                {t('footerDisclaimer')}
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-white text-sm mb-4">{t('footerLinks')}</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-white/60 hover:text-white transition">{t('navHome')}</Link></li>
                <li><a href="#articles" className="text-sm text-white/60 hover:text-white transition">{t('navGuides')}</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition">{t('ctaMain')}</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold text-white text-sm mb-4">{t('footerLegal')}</h4>
              <ul className="space-y-2">
                <li><span className="text-sm text-white/60">{t('footerPrivacy')}</span></li>
                <li><span className="text-sm text-white/60">{t('footerTerms')}</span></li>
                <li><span className="text-sm text-white/60">{t('footerEditorial')}</span></li>
                <li><span className="text-sm text-white/60">{t('footerSafety')}</span></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-white/40">{t('footerCopyright')}</p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-white/40">{t('footerLanguage')}:</span>
              <div className="flex items-center gap-2">
                {languages.map(lang => (
                  <button
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    className={`text-xs px-2 py-1 rounded transition ${i18n.language === lang.code ? 'bg-white/20 text-white' : 'text-white/40 hover:text-white'}`}
                  >
                    {lang.code.toUpperCase()}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}